import { Avatar } from "antd";
import { colourFor, initialsFor } from "../../../helpers/initials";

/**
 * InitialsAvatar — coloured circle with the user's 2-char initials.
 *
 * Shared across topbar, profile, user list, role list. No image upload —
 * BRD §1.3 avatar-image-upload was replaced with initials (see PRD).
 */
export default function InitialsAvatar({
  user,
  size = 40,
  className = "",
  style = {},
}) {
  const { id, firstName, lastName, name, fullName, email } = user || {};
  const initials = initialsFor({
    firstName,
    lastName,
    name: name || fullName,
    email,
  });
  const { bg, fg } = colourFor({ id, email, name: name || fullName });
  return (
    <Avatar
      size={size}
      className={className}
      style={{ backgroundColor: bg, color: fg, fontWeight: 600, ...style }}
    >
      {initials}
    </Avatar>
  );
}
